<template>
  <Notice>
    ご紹介いただく購入者様にてお使いいただけるクーポンです。<br />
    利用方法は、購入者様が購入フォームのクーポンコード欄に、こちらの招待クーポンコードをご入力いただくことでご利用可能です。
  </Notice>

  <b-card no-body>
    <div class="table-responsive">
      <table
        class="table table-flush align-middle table-row-bordered table-row-solid gy-4 gx-2 gs-9 mb-0"
      >
        <thead class="fs-7 fw-bold text-uppercase">
          <tr>
            <th>クーポン名</th>
            <th>有効期限</th>
            <th>招待クーポンコード</th>
          </tr>
        </thead>
        <tbody class="fs-6 text-gray-600">
          <tr v-for="coupon in coupons" :key="coupon.id">
            <td>{{ coupon.code }}</td>
            <td>{{ periodText(coupon) }}</td>
            <td>{{ coupon.personalCode }}</td>
          </tr>
          <tr v-if="!coupons.length">
            <td colspan="3" class="text-center text-muted py-6">
              現在ご利用いただける招待クーポンはありません。
            </td>
          </tr>
        </tbody>
      </table>

      <div class="mt-2 ms-4 mb-4">
        <strong>{{ coupons.length }}</strong> 件表示中です
      </div>
    </div>
  </b-card>
</template>

<script lang="ts" setup>
import { ref } from "vue";

import useGraphql from "@/composables/useGraphql";
import filters from "@/composables/filters";
import * as inviteCouponQueries from "@/graphql/queries/customers/invite_coupons";
import Notice from "@/components/molecules/common/shared/Notice.vue";

interface InviteCoupon {
  id: string;
  name: string;
  code: string;
  personalCode: string;
  discountAmount: number | null;
  discountRatio: number | null;
  limitCount: number | null;
  sDate: string | null;
  eDate: string | null;
}

const coupons = ref<InviteCoupon[]>([]);

useGraphql<InviteCoupon[]>(inviteCouponQueries.inviteCoupons).then((data) => {
  coupons.value = data ?? [];
});

function periodText(coupon: InviteCoupon): string {
  if (!coupon.sDate && !coupon.eDate) return "なし";
  const start = coupon.sDate ? filters.fullDateTime(coupon.sDate) : "";
  const end = coupon.eDate ? filters.fullDateTime(coupon.eDate) : "";
  return `${start} 〜 ${end}`;
}
</script>

<style lang="scss" scoped>
.table-responsive {
  th,
  td {
    white-space: nowrap;
    font-size: 12px;
  }
}
</style>
